import {
  AppRoute,
  AppRoutesDeclaration,
} from 'webcommon/shared';

export abstract class AppRouteService {
  abstract findByStateName(stateName: string): AppRoute | undefined;
  abstract findKeyByStateName(stateName: string): string | undefined;
  abstract getAppRoutes(): AppRoutesDeclaration;
  abstract setupAppRoutes(newAppRoutes: AppRoutesDeclaration): void;
}
